export default __webpack_public_path__ + "static/media/login_bg_hg@2x.9ce2939f.jpg";